import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import Menu from "antd/es/menu";
import { useIntl } from "react-intl";

import Activity from "@mapmycustomers/shared/types/entity/Activity";

import RoundButton from "@app/component/RoundButton";
import { activityListViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import { bulkToggleComplete } from "@app/scene/activity/store/actions";
import { getBulkToggleCompleteLoading } from "@app/scene/activity/store/selectors";
import { RootState } from "@app/store/rootReducer";
import { activityLayoutModel } from "@app/util/layout/impl";

interface Props {
  bulkToggleComplete: typeof bulkToggleComplete.request;
  bulkToggleCompleteLoading: boolean;
  className?: string;
  selected: Activity[];
}

const BulkToggleCompleteButton: React.FC<Props> = ({
  bulkToggleComplete,
  bulkToggleCompleteLoading,
  className,
  selected,
}) => {
  const intl = useIntl();
  const onMakeAllComplete = useCallback(() => {
    bulkToggleComplete({
      activities: selected.map((activity) => ({
        ...activity,
        layoutId: activityLayoutModel.getLayoutFor(activity).id,
      })),
      completed: true,
    });
  }, [bulkToggleComplete, selected]);
  const onMakeAllIIncomplete = useCallback(() => {
    bulkToggleComplete({
      activities: selected.map((activity) => ({
        ...activity,
        layoutId: activityLayoutModel.getLayoutFor(activity).id,
      })),
      completed: false,
    });
  }, [bulkToggleComplete, selected]);

  const handleClick = useCallback(() => {
    activityListViewAnalytics.clicked(["Checkbox to Select All", "Change Competion Status"]);
  }, []);

  return (
    <Dropdown
      key="menu"
      overlay={
        <Menu>
          <Menu.Item onClick={onMakeAllComplete}>
            {intl.formatMessage({
              id: "activity.listView.bulkToggleComplete.complete",
              defaultMessage: 'Mark all selected as "Done"',
              description: "Label for make selected as done option",
            })}
          </Menu.Item>
          <Menu.Item onClick={onMakeAllIIncomplete}>
            {intl.formatMessage({
              id: "activity.listView.bulkToggleComplete.incomplete",
              defaultMessage: 'Mark all selected as "Not yet done"',
              description: "Label for make selected as not yet done option",
            })}
          </Menu.Item>
        </Menu>
      }
      placement="bottomLeft"
      trigger={["click"]}
    >
      <RoundButton
        className={className}
        hasMenu
        leftIcon={<FontAwesomeIcon icon={faCheckCircle} />}
        loading={bulkToggleCompleteLoading}
        onClick={handleClick}
      >
        {intl.formatMessage({
          id: "activity.listView.bulkToggleComplete.changeCompleteStatus",
          defaultMessage: "Change status",
          description: "Label for bulk toggle completed button",
        })}
      </RoundButton>
    </Dropdown>
  );
};

const mapStateToProps = (state: RootState) => ({
  bulkToggleCompleteLoading: getBulkToggleCompleteLoading(state),
});

const mapDispatchToProps = {
  bulkToggleComplete: bulkToggleComplete.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkToggleCompleteButton);
